import styled         from "styled-components"
import ProfilePicture from "YConnect/Components/ProfilePicture"

const ProfilePictureStyle = styled(ProfilePicture)`
    border: ${props => props.theme.main.lightIvory } 10px solid
`

export default ProfilePictureStyle